import React, { useCallback } from "react";
import { useSetActivePartKey, useActivePartKey } from "stores/product";
import type { OrderCodePartStrict } from "stores/product";
import { OrderCodePartOption } from "./OrderCodePartOption";
import cx from "classnames";

export const OrderCodePart = ({
  part,
  isModal = false,
}: {
  part: OrderCodePartStrict;
  isModal?: boolean;
}) => {
  const options = part.options?.filter(
    (option) =>
      (option && !option.state) ||
      (option && option.state !== null && option.state < 2),
  );
  return (
    <OrderCodePartLayout part={part} isModal={isModal}>
      {options?.map(
        (option) =>
          option && (
            <OrderCodePartOption
              key={option.key}
              option={option}
              part={part}
              disabled={
                option.state === 1 || option.state === 3 || part.state === 1
              }
              isModal={isModal}
            />
          ),
      )}
    </OrderCodePartLayout>
  );
};

const OrderCodePartLayout = ({
  children,
  part,
  isModal = false,
}: {
  children: React.ReactNode;
  part: OrderCodePartStrict;
  isModal?: boolean;
}) => {
  const setActivePartKey = useSetActivePartKey();
  const activePartKey = useActivePartKey();
  const isActive = activePartKey === part.key;

  const onClick = useCallback(() => {
    setActivePartKey(part.key);
  }, [part, setActivePartKey]);

  return (
    <div
      data-testid={`part-${part.key}`}
      className="mt-3"
      id={isModal ? `modal-part-${part.key}` : `part-${part.key}`}
    >
      <a
        href={isModal ? `#modal-part-${part.key}` : `#part-${part.key}`}
        onClick={(e) => {
          e.preventDefault();
        }}
        draggable={false}
        className="text-reset text-decoration-none"
        aria-label={`Scroll to ${part.title}`}
        tabIndex={-1}
      />
      {!isModal && (
        <h5
          data-testid={`part-${part.key}-title`}
          onClick={onClick}
          className={cx("text-nowrap", {
            "text-info": isActive,
          })}
        >
          {part.title}
        </h5>
      )}
      <div
        data-testid={`part-${part.key}-onclick`}
        onClick={onClick}
        className="d-flex flex-wrap gap-4"
      >
        {children}
      </div>
    </div>
  );
};
